import { Component, type OnInit } from '@angular/core'
import {
  KcDataService
} from '../../../kc-data.service'
import { type KcRealmData, type KcClientData, type KcSamlPostData, type KcMessage } from '../../../interfaces/kc-data.interface'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { Router } from '@angular/router'

@Component({
  selector: 'customer-portal-app-revolution-saml-post',
  templateUrl: './revolution-saml-post.component.html',
  styleUrls: ['./revolution-saml-post.component.scss']
})
export class RevolutionSamlPostComponent implements OnInit {
  viewData: KcSamlPostData
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly transifexTranslationsService: TranslationService,
    private readonly router: Router
  ) {}

  public realmData: KcRealmData
  public clientData: KcClientData
  public message: KcMessage

  redirect (url: string) {
    setTimeout(() => {
      window.location.href = url
    }, 2000)
  }

  ngOnInit () {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcSamlPostData
    const messageTranslation = this.transifexTranslationsService.translate(
      'You logged in successfully, you will be redirected soon.',
      {
        _key: 'customerPortal.kc.login.redirect.message',
        _tags: 'kc-forms, 3.14'
      }
    )
    this.message = {
      type: 'info',
      summary: messageTranslation
    }
    if (this.viewData.url) {
      this.redirect(this.viewData.url)
    }
  }
}
